export default __webpack_public_path__ + "static/media/3.24040400.webp";